module.exports = __webpack_public_path__ + "/bundle/asset/U2_04-b531f7cf851a4d828eb2a39c2420731f.gif";